import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const policies = getMockPolicies(
  // No autopay, has ID card
  "CD829471-01",
  "CD829471-02",
  // No autopay, comp only
  "RG263345-00",
  "RG263345-01",
  // Autopay, has ID card
  "AM345634-01",
  "AM345634-02",
  // Autopay, comp only
  "NT432345-00",
  "NT432345-01",
);

export const maddieDuncan: MockPersona = {
  key: "maddieDuncan",
  name: "Maddie Duncan",
  description: "🇨🇦 | Multiple policies with documents and statements, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: policies,
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "maddie@duncan.com",
            firstName: "Maddie",
            middleName: "",
            lastName: "Duncan",
            mailingAddress: {
              line1: "13551 St Albert Trail NW",
              line2: "",
              city: "Edmonton",
              state: "AB",
              postalCode: "T5L 5E7",
              country: "CANADA",
            },
            preferredPhone: "7801712306",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000019",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
